import {
  put, takeLatest, call, all, fork, select,
} from 'redux-saga/effects';
import {
  forEach, values, chain, isFunction, map,
} from 'lodash';
import {
  FETCH_COMMISSION_ALL,
  FETCH_COMMISSION_BY_TIME,
  FETCH_COMMISSION_USER,
  FETCH_COMMISSION_USERS_PAGINATE,
  FETCH_COMMISSION_USER_BY_TIME, FETCH_TOTAL_REFERRAL,
  FETCH_LIST_MAP_LEVEL,
  FETCH_LIST_PARTNERS,
} from '../actions/commission/action_types';

import actions from '../actions/commission';
import rf from '../../requests/RequestFactory';

function* fetchCommissionAll(action) {
  try {
    const resp = yield call((params) => rf.getRequest('CommissionRequest')
      .fetchAll(params), action.params);
    const data = map(resp.data.list_coin, (value, props) => ({ symbol: props, value })) || [];
    const makeColorData = {};
    const coins = yield select((state) => state.setting.coins);
    for (const [symbol, coin] of Object.entries(coins)) {
      makeColorData[symbol] = {
        ...coin,
        symbol,
        value: 0,
      };
    }
    if (data.length !== 0) {
      forEach(data, (item) => {
        makeColorData[item.symbol] = { ...makeColorData[item.symbol], ...item };
      });
    }
    yield put(actions.fetchCommissionAllSucceed(chain(Object.values(makeColorData))
      .orderBy('value', 'desc')
      .value()));
  } catch (err) {
    console.log(err, 'err');
  }
}

function* fetchCommissionByTime(action) {
  try {
    const resp = yield call((params) => rf.getRequest('CommissionRequest')
      .fetchByTime(params), action.params);
    const data = map(resp.data.list_coin, (value, props) => ({ symbol: props, value })) || [];
    const makeColorData = {};
    const coins = yield select((state) => state.setting.coins);
    for (const [symbol, coin] of Object.entries(coins)) {
      makeColorData[symbol] = {
        ...coin,
        symbol,
        value: 0,
      };
    }
    if (data.length !== 0) {
      forEach(data, (item) => {
        makeColorData[item.symbol] = { ...makeColorData[item.symbol], ...item };
      });
    }
    yield put(actions.fetchCommissionAllSucceed(chain(Object.values(makeColorData))
      .orderBy('value', 'desc')
      .value()));
  } catch (err) {
    console.log(err, 'err');
  }
}

function* fetchCommissionUser(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('CommissionRequest')
      .fetchUser(params), action.params);
    yield put(actions.fetchCommissionUserSucceed(data));
  } catch (err) {
    console.log(err, 'err');
  }
}

function* fetchUsers(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('CommissionRequest')
      .fetchUsers(params), action.params);
    yield put(actions.fetchCommissionUsersSucceed(data));
  } catch (err) {
    console.log(err, 'err');
  }
}

function* fetchUserByTime(action) {
  try {
    const data = yield call((params) => rf.getRequest('CommissionRequest')
      .fetchUserByTime(params), action.params);
    yield put(actions.fetchCommissionUserByTimeSucceed(data));
  } catch (err) {
    console.log(err, 'err');
  }
}

function* fetchTotalReferrals(action) {
  try {
    const { data } = yield call(() => rf.getRequest('CommissionRequest')
      .fetchTotalReferrals());
    // yield put(actions.fetchCommissionUserByTimeSucceed(data));
    if (isFunction(action.callback)) {
      action.callback(data);
    }
    yield action.callback(data);
  } catch (err) {
    console.log(err, 'err');
  }
}

function* fetchListMapLevel(action) {
  try {
    const { data, totalCount } = yield call((params) => rf.getRequest('CommissionRequest')
      .fetchListMapLevel(params), action.params);
    yield put(actions.fetchListMapLevelSucceed(data));
    if (isFunction(action.callback)) {
      action.callback(totalCount);
    }
  } catch (err) {
    yield put(actions.fetchListMapLevelFailed(err));
  }
}

function* fetchListPartners(action) {
  try {
    const { data, total_count: totalCount } = yield call((params) => rf.getRequest('CommissionRequest')
      .fetchListPartners(params), action.params);
    yield put(actions.fetchListPartnersSucceed(data, totalCount));
    if (isFunction(action.callback)) {
      action.callback(totalCount);
    }
  } catch (err) {
    yield put(actions.fetchListPartnersFailed(err));
  }
}

function* watchCommission() {
  yield takeLatest(FETCH_COMMISSION_ALL, fetchCommissionAll);
  yield takeLatest(FETCH_COMMISSION_BY_TIME, fetchCommissionByTime);
  yield takeLatest(FETCH_COMMISSION_USER, fetchCommissionUser);
  yield takeLatest(FETCH_COMMISSION_USERS_PAGINATE, fetchUsers);
  yield takeLatest(FETCH_COMMISSION_USER_BY_TIME, fetchUserByTime);
  yield takeLatest(FETCH_TOTAL_REFERRAL, fetchTotalReferrals);
  yield takeLatest(FETCH_LIST_MAP_LEVEL, fetchListMapLevel);
  yield takeLatest(FETCH_LIST_PARTNERS, fetchListPartners);
}

export default function* rootSaga() {
  yield all([fork(watchCommission)]);
}
